<script>
  // The marker on the viewer's own Claim where they are dark in this server
  // (ADR-0021 decision 4: darkness never hides you from yourself, but it
  // says so). Shared by every surface that lists the viewer's Claims (binder
  // cards, group page, group search).
  /** @type {{ class?: string }} */
  let { class: extraClass = '' } = $props();
</script>

<span
  class="not-shared-here {extraClass}"
  title="Only you can see this here: you've hidden your binders from this server in Sharing settings."
>
  Not shared here
</span>

<style>
  .not-shared-here {
    display: inline-flex;
    align-items: center;
    padding: 1px 7px;
    border: 1px dashed var(--color-text-muted, #b5aa96);
    border-radius: 999px;
    background: var(--color-bg-surface, #ffffff);
    color: var(--color-text-secondary, #5a5040);
    font-size: 10px;
    font-weight: 600;
    line-height: 1.5;
    white-space: nowrap;
  }
</style>
